// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import DashboardOutlined from '/app/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
import ClockCircleOutlined from '/app/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/ClockCircleOutlined';
import HistoryOutlined from '/app/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/HistoryOutlined';
export default { DashboardOutlined, ClockCircleOutlined, HistoryOutlined };
